export const hasVisibleOfferBadge = (candidate = {}) => {
  const hasPurchasedTag = Number(candidate?.purchased_tag) === 1;
  const isAdminAssigned =
    String(candidate?.badge_status || '').toLowerCase() === 'assigned' &&
    Boolean(String(candidate?.badge_text || candidate?.offer || '').trim());

  return hasPurchasedTag || isAdminAssigned;
};

export const getVisibleOfferBadgeText = (candidate = {}) => {
  const badgeText = String(candidate?.badge_text || candidate?.offer || '').trim();
  return badgeText || 'Premium';
};

export const getAdminCustomSourceLabel = (candidate = {}) =>
  String(candidate?.admin_custom_source_label || '').trim();

export const hasCustomSourceLabel = (candidate = {}) =>
  Boolean(getAdminCustomSourceLabel(candidate));

export const hasVisibleActiveTag = (candidate = {}) => {
  const hasPaidActiveState = Number(candidate?.purchased_tag) === 1;

  return Number(candidate?.admin_active_tag) === 1 || hasPaidActiveState;
};

export const hasHighlightedSourceLabel = (candidate = {}) =>
  hasCustomSourceLabel(candidate) || hasVisibleActiveTag(candidate);

export const getVisibleSourceLabel = (candidate = {}) =>
  getAdminCustomSourceLabel(candidate) ||
  (hasVisibleActiveTag(candidate) ? 'Very Active' : (candidate?.source || 'Direct'));

/**
 * Formats the 'Apply for' country string by removing common prefixes like "Job in" or "Jobs in".
 * @param {string} value - The raw country string from the candidate data.
 * @returns {string} - The cleaned country string or 'Not specified' if empty.
 */
export const formatApplyForCountry = (value) => {
  if (!value) return 'Not specified';
  const cleaned = value.replace(/^Jobs?\s+in\s+/i, '').trim();
  if (!cleaned) return 'Not specified';
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
};
